import { render, staticRenderFns } from "./Thread.vue?vue&type=template&id=a7d96c04"
import script from "./Thread.vue?vue&type=script&lang=js"
export * from "./Thread.vue?vue&type=script&lang=js"
import style0 from "./Thread.vue?vue&type=style&index=0&id=a7d96c04&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports